import { render, staticRenderFns } from "./pad-operate.vue?vue&type=template&id=06c1a0b6&scoped=true"
import script from "./pad-operate.vue?vue&type=script&lang=js"
export * from "./pad-operate.vue?vue&type=script&lang=js"
import style0 from "./pad-operate.vue?vue&type=style&index=0&id=06c1a0b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c1a0b6",
  null
  
)

export default component.exports